import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { PmoProject } from '@/lib/pmoSummary';

/** The tenant's projects with health, progress, budget and freshness. Shared by the role home screens. */
export function usePortfolioProjects() {
  return useQuery({
    queryKey: ['home', 'projects'],
    staleTime: 60_000,
    queryFn: async (): Promise<PmoProject[]> => {
      const { data, error } = await supabase
        .from('projects_sync')
        .select('id,external_id,name,health,progress,budget,spent,updated_at')
        .order('name');
      if (error) throw new Error(error.message);
      return (data ?? []) as PmoProject[];
    },
  });
}
